import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { SupportRoutingModule } from './support-routing.module';
import { SupportHomeComponent } from './support-home/support-home.component';
import { UserCreateComponent } from './user-create/user-create.component';
import { UserListComponent } from './user-list/user-list.component';
import { ConsultDoctorSupportComponent } from './consult-doctor-support/consult-doctor-support.component';
import { ViewDetailsComponent } from './view-details/view-details.component';
import { SharedModule } from '../../shared/shared.module';
import { UtilitiesModule } from '../../shared/utilities/utilities.module';
import { MedicalProfessionSharedModule } from "../shared/medical-profession-shared.module";
import { UploadDocumentsSupportComponent } from './upload-documents-support/upload-documents-support.component';

@NgModule({
    declarations: [
        SupportHomeComponent,
        UserCreateComponent,
        UserListComponent,
        ConsultDoctorSupportComponent,
        ViewDetailsComponent,
        UploadDocumentsSupportComponent
    ],
    imports: [
        CommonModule,
        SupportRoutingModule,
        PrimengModule,
        SharedModule,
        UtilitiesModule,
        MedicalProfessionSharedModule
    ]
})
export class SupportModule { }
